import { Formik, Form } from "formik";
import axios from "axios";
import { useDispatch } from 'react-redux';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import CustomButton from "../../app/common/form/CustomButton";
import CustomText from "../../app/common/form/CustomText";
import CustomTextArea from "../../app/common/form/CustomTextArea";
import GreyHeading from "../../app/common/text/GreyHeading";
import { openModal } from "../../app/common/modals/modalReducer";

export function ContactForm() {
    const dispatch = useDispatch();

    const validationSchema = Yup.object({
        name: Yup.string().trim().required("Name is required"),
        surname: Yup.string().trim().required("Surname is required"),
        email: Yup.string().trim().email("Invalid email").required("Email is required"),
        message: Yup.string().trim().required("Reason is required"),
        // Optional fields
        organisation: Yup.string().nullable(),
        telephone: Yup.string().nullable(),
        lakato_account_number: Yup.string().nullable().max(20, "Max 20 characters"),
    });

    const initialValues = {
        name: "",
        surname: "",
        organisation: "",
        telephone: "",
        lakato_account_number: "",
        email: "",
        message: "",
    };

    return (
        <div className="bg-white">
            <Formik
                initialValues={initialValues}
                enableReinitialize="true"
                validationSchema={validationSchema}
                onSubmit={async (values, { setErrors }) => {
                    try {
                        await axios.post(process.env.REACT_APP_API_URL + "contact-us", values, {
                            headers: { Accept: "application/json" },
                        })
                            .then(() => {
                                dispatch(openModal({
                                    modalType: "ModalNotification", modalProps: {
                                        type: 'success',
                                        heading: 'Success',
                                        body: 'Your message has been sent',
                                        closeText: 'Close',
                                    }
                                }));
                            });
                    } catch (error) {
                        // Laravel validation failure
                        if (error?.response?.status === 422) {
                            toast.error("* fields are required", { position: "bottom-right", autoClose: 5000, closeOnClick: true });

                            const serverErrors = error?.response?.data?.errors;
                            if (serverErrors && typeof serverErrors === "object") {
                                const formikErrors = {};
                                Object.keys(serverErrors).forEach((key) => {
                                    const msg = serverErrors[key];
                                    formikErrors[key] = Array.isArray(msg) ? msg[0] : String(msg);
                                });
                                setErrors(formikErrors);
                            }

                            return;
                        }

                        dispatch(openModal({
                            modalType: "ModalNotification", modalProps: {
                                type: 'error',
                                heading: 'Something went wrong',
                                body: 'Please try again',
                                closeText: 'Close',
                            }
                        }))
                    }
                }}
            >
                {({ isSubmitting }) => (
                    <Form className="my-8 space-y-6 px-4 sm md:max-w-2xl lg:max-w-4xl xl:max-w-5xl m-auto" action="#" method="POST">
                        <ToastContainer />
                        <GreyHeading text="Send us a message" />
                        <p className="text-xs text-gray-500">* Required fields</p>

                        <div className="sm:grid sm:grid-cols-2 sm:gap-4">
                            <CustomText required label="Name *" type="text" name="name" />
                            <CustomText required label="Surname *" type="text" name="surname" />
                        </div>
                        <div className="sm:grid sm:grid-cols-2 sm:gap-4">
                            <CustomText label="Organisation" type="text" name="organisation" />
                            <CustomText label="Telephone" type="text" name="telephone" />
                        </div>
                        <div className="sm:grid sm:grid-cols-2 sm:gap-4">
                            <CustomText label="Lakato account number" type="text" name="lakato_account_number" maxLength={20} />
                            <CustomText required label="Email *" type="email" name="email" />
                        </div>
                        <div className="flex justify-center">
                            <CustomTextArea required label="Reason *" name="message" />
                        </div>
                        <div className="text-center">
                            <CustomButton
                                className={"bg-lk_red text-white hover:bg-lk_red_hover uppercase border_radius_4 py-3 px-8 m-auto text-base"}
                                disabled={isSubmitting}
                                submitBool={isSubmitting}
                                type="submit"
                                text={"Submit Message"}
                            />
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}
